/* eslint-disable import/order -- different order will break tests */
import type {ActionHandlers} from '@travel-frontend/state-handling-sdk';
import {
  createReducerUsingActionHandlers,
  ERROR,
  PENDING,
  SUCCESS,
} from '@travel-frontend/state-handling-sdk';
import type {Reducer, Selector} from '@/redux/types';
import type {
  FetchInventoryError,
  FetchInventoryPending,
  FetchInventorySuccess,
} from '@/redux/v1/hotels/inventory/actionTypes';
import {FETCH_INVENTORY} from '@/redux/v1/hotels/inventory/actionTypes';
import type {State} from '@/redux/v1/hotels/inventory/models';
import type {Inventory} from '@/redux/v1/models';
import {createSelector} from 'reselect';

import {inventoryState} from '@/redux/v1/hotels/hotelsState';

// @ts-expect-error ...
const EMPTY_ARRAY = [];

export const initialState: State = {
  loading: false,
};

// @ts-expect-error ...
const ignoreStaleResponses = (actionHandler) => (state, action) =>
  action.meta.requestId === state.lastRequest
    ? actionHandler(state, action)
    : state;

const actionCreators: ActionHandlers<State> = {
  [PENDING(FETCH_INVENTORY)]: (
    state: State,
    {meta}: FetchInventoryPending
  ) => ({
    ...state,
    loading: true,
    lastRequest: meta.requestId,
  }),
  [SUCCESS(FETCH_INVENTORY)]: ignoreStaleResponses(
    (state: State, {data}: FetchInventorySuccess) => ({
      ...state,
      loading: false,
      inventoryUnfiltered: data.inventoryUnfiltered,
      inventoryFiltered: data.inventoryFiltered,
      translations: data.translations,
    })
  ),
  [ERROR(FETCH_INVENTORY)]: ignoreStaleResponses(
    (state: State, {error}: FetchInventoryError) => ({
      ...state,
      loading: false,
      error,
    })
  ),
};

export const inventoryReducer: Reducer<State> =
  createReducerUsingActionHandlers<State>(initialState, actionCreators);

export const isInventoryLoaded: Selector<boolean> = createSelector(
  inventoryState,
  (state: State) => Boolean(state.inventoryUnfiltered)
);

export const isInventoryLoading: Selector<boolean> = createSelector(
  inventoryState,
  (state: State) => state.loading === true
);

export const getInventoryUnfiltered: Selector<Inventory> = createSelector(
  [inventoryState],
  (state: State) =>
    // @ts-expect-error ...
    state.inventoryUnfiltered ?? EMPTY_ARRAY
);

export const getInventoryFiltered: Selector<Inventory> = createSelector(
  [inventoryState],
  (state: State) =>
    // @ts-expect-error ...
    state.inventoryFiltered ?? EMPTY_ARRAY
);

export const selectTranslations: Selector<any> = (state) =>
  inventoryState(state).translations;
